import JobPostBase from './JobPostBase';

const JobPost = ({ teamDetails }) => {
    return <JobPostBase isAdmin={false} teamDetails={teamDetails} />;
};

export default JobPost;
